
import Vue from "vue"
import { mapGetters } from "vuex"

export default Vue.extend({
  async asyncData ({ route, redirect, app, $api }) {
    const goUp = () => redirect(app.localePath("/speakers"))

    const alias = route.params.alias
    if (!alias) return goUp()

    const [res, err] = await $api.person.getSpeakerData(alias)
    if (err) return goUp()

    return { speaker: res }
  },

  data: () => ({
    speaker: null,
  }),

  head () {
    return {
      title: this.getTitle(this.$fmt.name(this.speaker)),
    }
  },

  computed: {
    ...mapGetters("app", ["getTitle"]),
  },
})
